module.exports = __webpack_public_path__ + "img/body-1.3d0b6cb5.png";